import { type FC, useId } from "react";

import { PixelPlaceholderLoader } from "@similarweb/ui-components";
import { Stack } from "@similarweb/ui-components/foundations";

import { StyledListItemDescriptionLoader, StyledListItemLoaderWrapper, StyledListItemSimpleLoader } from "./styles";

type Props = {
    rowNumber: number;
};

const FiltersListLoader: FC<Props> = ({ rowNumber = 3 }) => {
    const loaderItems = [];

    const id = useId();

    for (let index = 1; index <= rowNumber; index++) {
        loaderItems.push(
            <StyledListItemLoaderWrapper key={`loader_${index}`}>
                <StyledListItemSimpleLoader>
                    <StyledListItemDescriptionLoader>
                        <PixelPlaceholderLoader
                            id={`filters-list-loader-${id}-title`}
                            width={244}
                            height={22}
                        />
                        <PixelPlaceholderLoader
                            id={`filters-list-loader-${id}-subtitle`}
                            width={180}
                            height={14}
                        />
                    </StyledListItemDescriptionLoader>
                </StyledListItemSimpleLoader>
            </StyledListItemLoaderWrapper>,
        );
    }

    return (
        <Stack
            gap="8px"
            minHeight="100%"
        >
            {loaderItems}
        </Stack>
    );
};

export default FiltersListLoader;
